<div class="layout-topbar">
  <div *ngIf="layoutService.isTabletView$ | async">
    <p-button
      icon="pi pi-bars"
      [text]="true"
      ariaLabel="Apri o chiudi il menu"
      (onClick)="layoutService.onMenuToggle()"
    ></p-button>
  </div>
  <div *ngIf="(layoutService.isTabletView$ | async) === false">
    <app-breadcrumbs></app-breadcrumbs>
  </div>

  <div class="layout-topbar-menu">
    <!-- Comando vero: un contenitore non viene annunciato come pulsante e il
         conteggio sul badge è solo grafico (WCAG 2.1.1, 4.1.2). -->
    <button
      type="button"
      class="layout-topbar-button"
      [attr.aria-label]="cartLabel()"
      (click)="navigateToCart()"
    >
      <i
        class="pi pi-shopping-cart"
        aria-hidden="true"
        pBadge
        [badgeDisabled]="cartItemsCount() === 0"
        [value]="cartItemsCount()"
      ></i>
    </button>

    <!-- Utente anonimo: nessuna scheda profilo, solo l'invito ad accedere. -->
    <p-button
      *ngIf="!isAuthenticated()"
      [label]="config.loginButtonLabel"
      icon="pi pi-sign-in"
      styleClass="topbar-login"
      (onClick)="login()"
    ></p-button>

    <button
      *ngIf="isAuthenticated()"
      type="button"
      class="topbar-user h-full flex align-items-center justify-content-center gap-3"
      [attr.aria-label]="'Apri il menu di ' + compactUser.name"
      aria-haspopup="menu"
      (click)="op.toggle($event)"
    >
      <ui-avatar-info
        [data]="compactUser"
        [config]="data.compactUserAvatarConfig"
      ></ui-avatar-info>
      <i class="pi pi-chevron-down text-sm text-muted" aria-hidden="true"></i>
    </button>
  </div>
  <p-popover #op>
    <ng-template #content>
      <ui-card [item]="config.overlayCardStyles">
        <div>
          <div class="px-6">
            <ui-avatar-info
              [data]="profileCardUser"
              [config]="data.profileCardAvatarConfig"
            ></ui-avatar-info>
          </div>
          <p-divider></p-divider>
          <div>
            <div class="w-full flex align-items-center justify-content-start mb-2">
              <span class="text-xl font-bold">{{ config.activePlansTitle }}</span>
            </div>

            <div *ngIf="isLoadingPlans()" class="flex flex-column gap-2">
              <p-skeleton height="1.75rem" borderRadius="8px"></p-skeleton>
              <p-skeleton height="1.75rem" borderRadius="8px"></p-skeleton>
            </div>

            <div *ngIf="!isLoadingPlans() && plansError()" class="text-sm text-color-secondary">
              Non è stato possibile caricare i piani.
              <p-button
                label="Riprova"
                [text]="true"
                size="small"
                styleClass="p-0 underline"
                (onClick)="reloadActivePlans()"
              ></p-button>
            </div>

            <div
              *ngIf="!isLoadingPlans() && !plansError() && !activePlans().length"
              class="text-sm text-color-secondary"
            >
              {{ config.noActivePlansText }}
            </div>

            <!-- Un piano per licenza aperta. "Gestisci" apre l'app gestionale. -->
            <div
              *ngFor="let plan of activePlans(); trackBy: trackActivePlan"
              class="w-full flex align-items-center justify-content-between gap-2"
            >
              <span class="flex flex-column">
                <span class="text-sm">{{ plan.planName }}</span>
                <span class="text-xs text-color-secondary">{{ plan.reference }}</span>
              </span>
              <!-- Senza accesso consentito non c'è nulla da gestire: si mostra
                   solo lo stato, a parole. -->
              <p-button
                *ngIf="plan.accessAllowed"
                [label]="config.manageButtonLabel"
                size="small"
                [text]="true"
                styleClass="p-1 underline"
                icon="pi pi-external-link"
                iconPos="right"
                (onClick)="manageActivePlan(plan)"
              ></p-button>
              <span *ngIf="!plan.accessAllowed" class="text-xs text-color-secondary">
                {{ plan.stateLabel }}
              </span>
            </div>
          </div>
          <p-divider></p-divider>
          <div class="w-full flex align-items-center justify-content-center mb-2">
            <p-button
              class="w-full mt-2"
              [label]="config.logoutButtonLabel"
              severity="danger"
              [outlined]="true"
              styleClass="w-full"
              iconPos="right"
              (click)="logout()"
            ></p-button>
          </div>
        </div>
      </ui-card>
    </ng-template>
  </p-popover>
</div>
